import {Component, OnInit, Inject, ViewChild} from '@angular/core';
import {ErrorStateMatcher, DateAdapter, MAT_DATE_LOCALE} from '@angular/material/core';
import {MatTableDataSource} from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import {FormBuilder, FormGroup, FormControl, FormGroupDirective, NgForm} from '@angular/forms';
import {ConfirmComponent} from '../../../shared/dialogs/confirm/confirm.component';
import {ProductService} from '../../../services/product.service';
import {Product, ProductItem} from '../../../models/product';
import {AuthService} from '../../../services/auth.service';
import {SnackBarIconService} from '../../../shared/snack-bar-icon/snack-bar-icon.service';

import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import {Lot} from 'src/app/models/lot';
import {ProductLotDialogComponent} from '../product-lot-dialog/product-lot-dialog.component';
import {ProductLotService} from 'src/app/services/product-lot.service';
import {RefundService} from 'src/app/services/refund.service';
import {Refund} from 'src/app/models/refund';
import {ProductRefundDialogComponent} from '../product-refund-dialog/product-refund-dialog.component';
import {BannerDialogComponent} from 'src/app/event/dialogs/banner-dialog/banner-dialog.component';
import {AngularFireStorage, AngularFireStorageReference, AngularFireUploadTask} from '@angular/fire/compat/storage';


import {finalize} from 'rxjs/operators';
import {ProductCatPriceService} from 'src/app/services/product-cat-price.service';

/** Error when invalid control is dirty, touched, or submitted. */
export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState (control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-product-dialog',
  templateUrl: './product-dialog.component.html',
  styleUrls: [ './product-dialog.component.scss' ],
  entryComponents: [
    ConfirmComponent
  ],
  providers: [
    {provide: MAT_DATE_LOCALE, useValue: 'pt-BR'}
  ]
})

export class ProductDialogComponent implements OnInit {

  public Editor = ClassicEditor;
  public matcher = new FormErrorStateMatcher();
  public productForm: FormGroup;
  public itemForm: FormGroup;

  public displayedItemColumns: string[] = [ 'icon', 'event_name', 'delete' ];
  public displayedLotColumns: string[] = [ 'icon', 'until_date', 'name', 'edit', 'delete' ];
  public displayedCatProductColumns: string[] = [ 'icon', 'name', 'value', 'limit', 'edit', 'delete' ];
  public displayedRefundColumns: string[] = [ 'icon', 'date', 'percent', 'edit', 'delete' ];

  public productItemAdded: ProductItem;
  public selectedItemOk: boolean = false;

  public allProducts: any[] = [];

  public selectedRequiredProduct: any = {};
  public selectedRequiredProduct_id: any

  public displayedRequirementsColumns: string[] = [ 'icon', 'name', 'delete' ];

  public part_of_list: any[] = []
  @ViewChild(MatSort, {static: false}) sort: MatSort;

  public sponsorsDataSource: MatTableDataSource<any>
  public displayedSponsorColumns: string[] = [ 'image', 'link', 'type', 'delete' ];

  constructor (
    private fs: AngularFireStorage,
    private fb: FormBuilder,
    private dialog: MatDialog,
    public _productService: ProductService,
    public _refundService: RefundService,
    public _productLotService: ProductLotService,
    private _authService: AuthService,
    private snackBar: SnackBarIconService,
    private _adapter: DateAdapter<any>,
    private _productCatPriceService: ProductCatPriceService,
    @Inject(MAT_DIALOG_DATA) public data: Product) {

    if (this.data.id)
      this._refundService.loadRefunds(this.data.id);

  }


  ngOnInit () {
    // console.log("product_id: " + this.data.id)
    this._adapter.setLocale('pt');

    this._productService.currentProduct = this.data;
    this._productService.productRequirementsDataSource = new MatTableDataSource(this._productService.currentProduct.requirements);

    this._productService.storedImage = this._productService.currentProduct.image
    this._productService.storedImage_en = this._productService.currentProduct.image_en

    this._productService.storedButton = this._productService.currentProduct.button
    this._productService.storedButton_en = this._productService.currentProduct.button_en

    //this._productService.storedWaiting = this._productService.currentProduct.image_waiting

    this._productService.setEdit()

    this._productService.productItensDataSource = new MatTableDataSource([]);

    this.productForm = this._productService.createForm(this._productService.currentProduct)
    this.itemForm = this._productService.createItemForm();

    this.loadBannerSponsors();

    this.part_of_list.push({'id': -1, 'name': 'none'})
    this.part_of_list.push({'id': 0, 'name': 'Congresso'})
    this.part_of_list.push({'id': 1, 'name': 'Curso'})
    this.part_of_list.push({'id': 2, 'name': 'Prova'})
    // this.part_of_list.push({'id': 3, 'name': 'Anuidade'})
  }

  ngAfterViewInit () {
    //  this._productService.loadProducts()
    // this._productService.loadCategories()
   
    this._productService.loadEventsForProducts()
    // this._productService.loadEvents()

    if (this._productService.isEdit) {
      this._productService.loadProductItens(this._productService.currentProduct.id)
      this._productLotService.loadProductLots(this._productService.currentProduct.id, this.sort)
    }

    this.loadProducts();

  }

  loadProducts () {

    this._productService.selectProducts()
      .subscribe((result) => {
        result.forEach((item) => {
          this.allProducts.push({
            "id": item.payload.doc.id,
            "name": item.payload.doc.data().name
          })
        })
      })

  }

  insert () {
    if (this.productForm.valid) {
      this._productService.insert(this.productForm.value)
    }
  }

  update () {
    if (this.productForm.valid) {
      let updatedProduct = this.productForm.value
      //  updatedProduct.requirements = this._productService.currentProduct.requirements
      console.log("updatedProduct: " + JSON.stringify(updatedProduct))
      this._productService.update(updatedProduct)
    }
  }

  updateChecks () {

    const data = this.productForm.getRawValue()
    const config = {
      'available': data.available,
      'isAnnuity': data.isAnnuity,
      'onlyForVaccinated': false,
      'available_purchase': data.available_purchase,
      'available_schedule': data.available_schedule,
      'url_schedule': data.url_schedule,
      'part_of': data.part_of
    }
    //console.log(JSON.stringify(config))
    this._productService.updateChecks(this._productService.currentProduct.id, config)

  }

  selectItem (event) {

    if (event) {
      this.selectedItemOk = true
    }
    const evt = this._productService.arrayEvents.find(function (e) {
      return e.id == event;
    });

    this.productItemAdded = new ProductItem();
    this.productItemAdded.event_id = evt.id;
    this.productItemAdded.event_name = evt.name;
    this.productItemAdded.product_id = this._productService.currentProduct.id;
  }

  addItem () {
    console.log("productItemAdded: " + JSON.stringify(this.productItemAdded))
    this._productService.addItem(this.productItemAdded);
    this.productItemAdded = null;
  }


  removeItem (element) {

    let dialogRef = this.dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: {title: "Confirme", message: element.event_name + "<br><br>Remover este evento deste produto?"}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == "ok") {

        this._productService.deleteItem(element.id)
          .then(
            () => {
              this.snackBar.openSnackBar("Sucesso!", '', 'success')
            }
          )
          .catch(
            (error) => {console.log("delete product error: " + error.message)}
          )
      }
    })
  }


  deleteLot (element) {

    let dialogRef = this.dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: { title: "Confirme", message: element.name + "<br><br>Excluir este lote?" }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == "ok") {
        this._productCatPriceService.delete(element.id);
        this._productLotService.delete(element.id);
      }
    })

  }


  openLotDialog (element) {

    let data: Lot = new Lot();

    if (element) {
      data = element;
    }

    this.dialog.open(ProductLotDialogComponent, {
      width: '910px',
      height: '570px',
      panelClass: 'custom-dialog-container',
      data: {lot: data, product: this._productService.currentProduct}
    });
  }

  openRefundDialog (element) {

    let data: Refund = new Refund();

    if (element) {
      data = element;
    } else {
      data.product_id = this._productService.currentProduct.id
    }

    this.dialog.open(ProductRefundDialogComponent, {
      width: '430px',
      height: '300px',
      panelClass: 'custom-dialog-container',
      data: data
    });
  }


  /*
    openCatLotDialog(element) {
  
      let data: CategoryPrice = new CategoryPrice();
  
      if (element) {
        data = element;
      }
  
      this.dialog.open(ProductCatLotDialogComponent, {
        width: '830px',
        height: '590px',
        panelClass: 'custom-dialog-container',
        //data: { lot_id: "OjaIWetovAxKD0MFwxGS", product: this.data, catPrice: element }
        data: { lot_id: data.id, product: this.data, catPrice: element }
      });
    }
  */

  selectRequiredProduct (event) {
    this.selectedRequiredProduct = this.allProducts.find((e) => {
      return e.id == event
    })

    this.selectedRequiredProduct_id = this.selectedRequiredProduct.id

  }

  addRequirement () {
    this._productService.addRequirement(this.selectedRequiredProduct)
  }


  removeRequirement (element) {
    // console.log(JSON.stringify(element))

    let dialogRef = this.dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: {title: "Confirme", message: element.product_name + "<br><br>Excluir este pré-requisito?"}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == "ok") {

        this._productService.removeRequirement(element.id)

      }
    })
  }


  addProductDiscount () {

    console.log("discount_product_id: " + this.productForm.controls.discount_product_id.value)
    console.log("discount_percent: " + this.productForm.controls.discount_percent.value)

  }

  deleteRefund (element) {
    let dialogRef = this.dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: {title: "Confirme", message: element.percent + "<br><br>Excluir este reembolso?"}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == "ok") {
        this._refundService.delete(element.id)
      }
    })
  }


  loadBannerSponsors () {
    if (this._productService.currentProduct.sponsors && this._productService.currentProduct.sponsors.length > 0) {
      //  console.log('this._productService.currentProduct.sponsors ' + JSON.stringify(this._productService.currentProduct.sponsors))
      this.sponsorsDataSource = new MatTableDataSource(this._productService.currentProduct.sponsors)
    }
  }

  updateBannerSponsor (banner) {

    if (!this._productService.currentProduct.sponsors) {
      this._productService.currentProduct.sponsors = []
    }

    this._productService.currentProduct.sponsors.push(banner)
    this.sponsorsDataSource = new MatTableDataSource(this._productService.currentProduct.sponsors)

    this._productService.updateBannerSponsor(this._productService.currentProduct.id, this._productService.currentProduct.sponsors)

  }

  removeBannerSponsor (element) {

    let dialogRef = this.dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: {title: "Confirme", message: element.link + "<br><br>Excluir este banner?"}
    });

    dialogRef.afterClosed().subscribe(result => {

      if (result == "ok") {
        this._productService.currentProduct.sponsors = this._productService.currentProduct.sponsors.filter((e) => {
          return e.id != element.id;
        })

        this.sponsorsDataSource = new MatTableDataSource(this._productService.currentProduct.sponsors)
        //  console.log("this._eventService.currentEvent.sponsors: " + JSON.stringify(this._eventService.currentEvent.sponsors))
        this._productService.updateBannerSponsor(this._productService.currentProduct.id, this._productService.currentProduct.sponsors)
          .then(() => {

            const fsRef: any = this.fs.storage.refFromURL(element.image);
            fsRef.delete();

          })

      }
      else {
        return result
      }

    })


  }

  openBannerDialog () {

    let dialogRef = this.dialog.open(BannerDialogComponent, {
      width: '600px',
      height: '470px',
      hasBackdrop: true,
      disableClose: true,
      panelClass: 'custom-dialog-container',
      data: {'isProduct': true}
    })

    dialogRef.afterClosed()
      .subscribe(response => {
        if (!response) {
          return;
        }

        const bannerForm: FormGroup = response[ 0 ];
        const objectBanner: any = response[ 1 ];

        const formData = bannerForm.getRawValue();

        let banner: any = {};

        banner.id = new Date().getTime();
        banner.link = formData.link || '';
        banner.type = Number(formData.type)

        const fsRef: AngularFireStorageReference = this.fs.ref("images/banner_sponsors/" + "banner_" + banner.id + ".png");
        const fsTask: AngularFireUploadTask = fsRef.put(objectBanner);

        fsTask.snapshotChanges().pipe(
          finalize(() => {
            fsRef.getDownloadURL().subscribe(url => {
              banner.image = url;
              this.updateBannerSponsor(banner);
            });
          }))
          .subscribe();
      })
  }

}